export const DEFAULT_PS_MODAL_PANEL_CLASS = 'custom-ps-dialog-container';
export const ERRORS_PS_DIALOG_CONTAINER = 'errors-ps-dialog-container';

export const PS_MODAL_ANIMATION_DURATION = 500;

export const DEFAULT_PS_MODAL_WIDTH = 580;
export const DEFAULT_PS_MODAL_HEIGHT = 580;

export const SM_PS_MODAL_WIDTH = 500;
export const SM_PS_MODAL_HEIGHT = 320;

export const MD_PS_MODAL_WIDTH = 1000;
export const MD_PS_MODAL_HEIGHT = 580;

export const LG_PS_MODAL_WIDTH = 1480;
export const LG_PS_MODAL_HEIGHT = 720;

export const DEFAULT_PS_MODAL_SIZES = {
	width: `${DEFAULT_PS_MODAL_WIDTH}px`,
	height: `${DEFAULT_PS_MODAL_HEIGHT}px`,
};

export const SM_PS_MODAL_SIZES = {
	width: `${SM_PS_MODAL_WIDTH}px`,
	height: `${SM_PS_MODAL_HEIGHT}px`,
};
